import { createApi } from "@reduxjs/toolkit/query/react";
import { baseApiQuery } from "../../../shared/api";
import { BaseResponse } from "../../../shared/types";
import {
  CreateFieldActivityRequest,
  FieldActivitiesResponse,
  FieldActivityResponse,
  UpdateFieldActivityRequest,
} from "./types";

export const fieldActivitiesApi = createApi({
  reducerPath: "fieldActivitiesApi",
  baseQuery: baseApiQuery,
  tagTypes: ["FieldActivities"],
  endpoints: (builder) => ({
    getFieldActivities: builder.query<FieldActivitiesResponse, void>({
      query: () => "/admin/fieldactivities",
      providesTags: ["FieldActivities"],
    }),

    createFieldActivity: builder.mutation<
      FieldActivityResponse,
      CreateFieldActivityRequest
    >({
      query: (body) => ({
        url: "/admin/fieldactivities",
        method: "POST",
        body,
      }),
      invalidatesTags: ["FieldActivities"],
    }),

    updateFieldActivity: builder.mutation<
      FieldActivityResponse,
      { id: number; body: UpdateFieldActivityRequest }
    >({
      query: ({ id, body }) => ({
        url: `/admin/fieldactivities/${id}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: ["FieldActivities"],
    }),

    deleteFieldActivity: builder.mutation<BaseResponse, number>({
      query: (id) => ({
        url: `/admin/fieldactivities/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["FieldActivities"],
    }),
  }),
});

export const {
  useGetFieldActivitiesQuery,
  useCreateFieldActivityMutation,
  useUpdateFieldActivityMutation,
  useDeleteFieldActivityMutation,
} = fieldActivitiesApi;
